import {handleError} from '../utils/errorHandling';
import httpClient from './httpClient';

class FavouritesService {
  public async getFavouritedArtisticObjectIds(): Promise<string[]> {
    return handleError(
      () => httpClient.get<string[]>('/favourites/items'),
      'Error fetching favourited items:',
      () => []
    );
  }

  public async addToFavourites(artisticObjectId: string): Promise<void> {
    return handleError(
      () => httpClient.post<void>(`/favourites/items/${artisticObjectId}`),
      'Error adding item to favourites:'
    );
  }

  public async removeFromFavourites(artisticObjectId: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/favourites/items/${artisticObjectId}`),
      'Error removing item from favourites:'
    );
  }

  public async mergeFavourites(artisticObjectIds: string[]): Promise<void> {
    return handleError(
      () => httpClient.post<void>('/favourites/merge', artisticObjectIds),
      'Error merging favourites:'
    );
  }
}

const favouritesService = new FavouritesService();
export default favouritesService;

